import { Alert, Body, Panel } from "@livingdesign/react";
import React from "react";
import WarningPanelStyles from "./WarningPanelStyles.Styles";

const WarningPanel = (props) => {
  const { isOpen, setIsOpen, title, description, alertMessage, children, variant = null } = props
  const classes = WarningPanelStyles();

  /*
  * Function to close the panel
  */
  const handleClosePanel = () => {
    setIsOpen(false)
  }

  return (
    <Panel
      isOpen={isOpen}
      onClose={handleClosePanel}
      position="right"
      size="medium"
      title={title}
    >
      <div className={classes.alertWrap}>
        <Alert
          variant={variant}
        >
          {alertMessage}
          <div className={classes.textStyle}>
            <Body as="p" size="medium" weight={700}>
              {description}
            </Body>
          </div>
        </Alert>
      </div>
      {children}
    </Panel >
  )
}

export default WarningPanel
